import React, { useContext } from 'react';
import classnames from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isLongTitle } from '../../helpers';
import s from './Title.scss';
const Title = ({ title, showTitle, className })=>{
    const isMobile = useContext(MobileContext);
    if (!title || !showTitle) {
        return isMobile ? null : /*#__PURE__*/ React.createElement("div", {
            className: className
        });
    }
    return /*#__PURE__*/ React.createElement("h1", {
        "data-hook": BiDataHook.DEVIATION_TITLE,
        className: classnames(s['root'], isLongTitle(title) && s['long'], className)
    }, title);
};
Title.displayName = 'Title';
export default Title;
